import { combineReducers } from 'redux';

//For dispatch state
import profileState from './profileState';
import statusState from './statusState'
import statusLogin from './statusLogin';
import registerState from './registerState';
import {loanState, loanDetailState} from './loanState';
import {notifState, disburseState, paymentState, tipeJaminanState, tipePinjamanState} from './listState';
import {negosiasiState} from './negosiasi'
import {loanAgreementState} from './loanAgreementState';
import tnc from './tnc'
import { lengkapiProfil } from './lengkapiProfil'


const rootReducer = combineReducers({
	statusState, statusLogin, registerState, notifState, loanState, disburseState, paymentState, loanDetailState,
	negosiasiState, loanAgreementState, tipeJaminanState, tipePinjamanState, profileState, tnc, lengkapiProfil
})

export default rootReducer;